export default {
	UPDATE_USER: 'users/update'
}